module.exports = __webpack_public_path__ + "img/icon_map_ljsf_c.1f5c72b1.png";